import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateOdoBankAccountRequestSchema,
  TCreateOdoBankAccountResponseSchema,
} from "./createBankAccount.schema";

export const createBankAccount = (axios: IAxiosInstance) => {
  return async (body: TCreateOdoBankAccountRequestSchema) => {
    const { odo_user_id, ...rest } = body;

    const response = await axios.noRetry.post<
      IApiResponse<TCreateOdoBankAccountResponseSchema>
    >(`/api/employees/${odo_user_id}/bank-accounts`, rest);

    return response.data;
  };
};
